// @see https://bitbucket.org/flightscope/dto-schema/src/778936f4e7e6f5404a0f1dfc8657c5fec8f173f0/baseball/entity/player-substitution.json#lines-18

const SubstitutionType = {
    // https://www.baseball-reference.com/bullpen/Pinch_hitter
    PinchHitter: { key: 'PH', name: 'Pinch Hitter', short: 'PH', description: 'A pinch hitter is a batter used as a substitute for another batter. A pinch hitter only comes into the game when the batter whose turn he is taking is due to bat.'},

    // https://www.baseball-reference.com/bullpen/Defensive_substitute
    DefensiveSubstitute: { key: 'DS', name: 'Defensive', short: 'DS', description: 'A defensive substitute is a substitute who replaces a fielder.'},

    // https://www.baseball-reference.com/bullpen/Pinch_runner
    PinchRunner: { key: 'PR', name: 'Pinch Runner', short: 'PR', description: 'A pinch runner is a substitute used for a runner who is already on base.'},

    PitchingChange: { key: 'PC', name: 'Pitching Change', short: 'PC', description: 'A pitching change is a substitute who replaces a pitcher.'},

    Other: { key: 'OT', name: 'Substitution', short: 'OT', description: 'Other type of substitution.'},
};

export default SubstitutionType;